import React from 'react'
import Select from 'react-select'
import { ButtonOutline } from '../index'
import { formUpdater, inputNormalizer } from '../../utils'
import PropTypes from 'prop-types'
import { useInternationalization } from '../../features/i18n'

const label = {
  en: "Choose action",
  id: 'Pilih aksi'
}

const TableAction = ({requesting, onSubmit}) => {
  const [form, setForm] = React.useState({})
  const updateForm = (e) => formUpdater(e, form, setForm)
  const { translate, language } = useInternationalization()

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <form onSubmit={handleSubmit} className="flex items-center">
      <Select
        placeholder={label[language.name]}
        options={[
          { label: translate('GENERAL', 'delete'), value: 'delete' }
        ]}
        className="text-sm mr-4 lg:mr-2 w-full lg:w-1/4"
        onChange={({value}) => inputNormalizer(value, 'action', updateForm)}
      />
      <ButtonOutline
        outlineColor="primary"
        className="text-primary"
        style={{maxWidth: '87px'}}
        disabled={requesting}
        isLoading={requesting}
      >
        <span>{translate('SORT', 'apply')}</span>
      </ButtonOutline>
    </form>
  )
}

TableAction.propTypes = {
  requesting: PropTypes.bool,
  onSubmit: PropTypes.func
}

TableAction.defaultProps = {
  requesting: false,
  onSubmit: () => {},
}

export { TableAction }
